<template>
    <article class="teaser teaser-course">
        <div class="teaser-course__inner">
            <div class="teaser-course__body">
                <h2 class="heading--4 teaser-course__title"><a :href="link" class="teaser__title-link">{{ title }}</a></h2>
                <div class="teaser-course__text" v-html="excerpt"></div>
              
                <div class="teaser-course__meta">
                    <div class="teaser-vacancy__meta-duration" v-if="date"><Icon name="clock" color="a" /> {{ course_duration }}</div>
                    <!-- <div v-if="date"><Icon name="clock" color="a" /> {{ getDaysFrom(date)}}</div> -->
                    <div class="teaser-vacancy__meta-price" v-if="price"><Icon name="circle-checkmark" color="a" /> {{ price}}</div>
                    <div class="teaser-vacancy__meta-location" v-if="locations"><Icon name="marker" color="a"  /> {{ locations }}</div>          
                </div>
            </div>
        </div>
    </article>
</template>
<script>

import { createDateFilter } from "vue-date-fns";
import { formatDistanceStrict }  from 'date-fns';
import locale from "date-fns/locale/nl";

import { store } from './store.js';
import Icon from './Icon.vue';
export default {
    name: 'CourseTeaser',
    props: [
        'title',
        'link',
        'excerpt',
        'date',
        'locations',
        'course_duration',
        'price'
    ],
    filters: {
        date: createDateFilter("dd MMMM yyyy", { locale })
    },
    data() {
        return {
            store
        }
    },
    components: {
        Icon
    },
    
    mounted: function() {
       //
    },
    methods: {
        getDaysFrom(date) {
            const now = new Date();
            const distance = formatDistanceStrict(new Date(date), now, { locale});
            return distance;
        }
    }
};
</script>